function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { NumericFormat as DefaultNumericFormat } from "react-number-format";
import { useNumericConventionContext } from "../../contexts/NumericConventionContext";
function NumericFormat(props) {
  var _useNumericConvention = useNumericConventionContext(),
    numericConvention = _useNumericConvention.numericConvention;
  return /*#__PURE__*/React.createElement(DefaultNumericFormat, _extends({
    thousandsGroupStyle: numericConvention.thousandsGroupStyle,
    thousandSeparator: numericConvention.thousandSeparator,
    decimalSeparator: numericConvention.decimalSeparator
  }, props));
}
export default NumericFormat;